import * as REDUX_TYPES from '../types'

export const MINT_STAGES = {
    INIT:0,
    ROYALTY: 1,
    START: 2,
    PROGRESS: 3,
    HARMONIZE: 4,
    HARMONIZE_ASSISTANT: 5,
    HARMONIZE_ISSUE: 6
}
export const INITIAL_STATE = {
    currentIssue: 0, //Current share issue for the token, if any
    mediaHash: undefined,
    mintRoyalty: 0, //Royalty paid to token creator on all subsequent sales
    mintStage: MINT_STAGES.INIT, //See  MINT_STAGES
    description: undefined,
    nftMessage: undefined,
    messageId: undefined,
    name: undefined,
    price: 0,//price in eth. Note that the contract and the database require this as a Gwei string
    copyright: undefined,
    rightsUsageTerms: undefined,
    tokenId: undefined //The uint256 string for the NFT
}

const nftReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case REDUX_TYPES.NFT.UPDATE:
            return {
                ...state,
                mediaHash: action.nft.mediaHash,
                description: action.nft.description,
                messageId: action.nft.messageId,
                name: action.nft.name,
                price: action.nft.price,
                tokenId: action.nft.tokenId,
            }
        case REDUX_TYPES.NFT.CURRENT_ISSUE:
            return {
                ...state,
                currentIssue: action.currentIssue,
            }

        case REDUX_TYPES.NFT.MEDIA_HASH:
            return {
                ...state,
                mediaHash: action.mediaHash,
            }
        case REDUX_TYPES.NFT.DESCRIPTION:
            return {
                ...state,
                description: action.description,
            }
        case REDUX_TYPES.NFT.MESSAGE:
            return {
                ...state,
                nftMessage: action.nftMessage,
            }
        case REDUX_TYPES.NFT.MESSAGE_ID:
            return {
                ...state,
                messageId: action.messageId,
            }
        case REDUX_TYPES.NFT.NAME:
            return {
                ...state,
                name: action.name,
            }
        case REDUX_TYPES.NFT.MINT_ROYALTY:
            return {
                ...state,
                mintRoyalty: action.mintRoyalty,
            }
        case REDUX_TYPES.NFT.MINT_STAGE:
            return {
                ...state,
                mintStage: action.mintStage,
            }

        case REDUX_TYPES.NFT.PRICE:
            return {
                ...state,
                price: action.price,
            }
        case REDUX_TYPES.NFT.TOKEN_ID:
            return {
                ...state,
                tokenId: action.tokenId,
            }
        case REDUX_TYPES.NFT.RESET:
            return INITIAL_STATE
        default:
            return state
    }
}
export default nftReducer